import { render, staticRenderFns } from "./OrderError.vue?vue&type=template&id=5d09314a&scoped=true"
import script from "./OrderError.vue?vue&type=script&lang=ts"
export * from "./OrderError.vue?vue&type=script&lang=ts"
import style0 from "./OrderError.vue?vue&type=style&index=0&id=5d09314a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d09314a",
  null
  
)

export default component.exports